import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
// import element from '%/elCompsLogSign'
import i18n from './i18n';
import i18nModule from './mixins/i18nModule';
import SpMessage from '@/components/common/SpMessage';
process.env.NODE_ENV !== 'production' && require('@/mock/index');
const app = createApp(App).use(i18n);
// if (element.components) {
//   element.components.forEach(component => {
//     app.component(component.name, component)
//   })
// }
// if (element.plugins) {
//   (element.plugins.forEach(plugin => {
//     app.use(plugin)
//   }))
// }
app.use(SpMessage);
// 注册公共组件
// const locales = require.context('./components/common', true, /[A-Za-z0-9-_,\s]+\.vue$/i)
// locales.keys().forEach(key => {
//   const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//   if (matched && matched.length > 1) {
//     const name = matched[1]
//     if (name.indexOf('Sp') !== -1) {
//       app.component(name, locales(key).default)
//     }
//   }
// })
app.mixin(i18nModule);
app.use(store).use(router).mount('#app');
